

const list = (search, access_token) => {
    console.log('points list')
    return new Promise((resolve, reject) => {
        axios.get('/api/point/list', {
            params: { s: search ? search : null },
            headers: { Authorization: 'Bearer ' + access_token }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

const summary = (access_token) => {
    console.log('points summary')
    return new Promise((resolve, reject) => {
        axios.get('/api/point/summary', {
            headers: { Authorization: 'Bearer ' + access_token }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

export {
    list,
    summary
}